module.exports = __webpack_public_path__ + "static/media/QC.43122a93.svg";